import text from './text.json'
import {useDispatch, useSelector} from 'react-redux'
import {Formik} from 'formik'
import Input from '../../components/core/input'
import {SimpleBlueButton} from '../../components/core/button'
import {teamSchema} from '../../utils/validation'
import {handleFormChanges} from '../../utils/forms'
import {setButtonIsDisabled, updateService} from '../../stores/resources'
import ButtonLoader from '../../components/core/button/ButtonLoader'

const EditPopup = ({service, closeModal, setClickedService}) => {
    const buttonIsDisabled = useSelector(state => state.resources.buttonIsDisabled)
    const showLoader = useSelector(state => state.resources.showLoader)
    const dispatch = useDispatch()
    const initialFormValues = {
        name: service?.label,
        id: service?.value
    }
    const editService = (values, {setFieldError}) => {
        let formData = {
            name: values.name
        }
        dispatch(updateService(values.id, formData, setFieldError, closeModal))
        dispatch(setButtonIsDisabled(true))
        setClickedService(null)
    }
    return (
        <div className="modal-body">
            <Formik
                enableReinitialize={true}
                initialValues={initialFormValues}
                onSubmit={editService}
                validationSchema={teamSchema}
                validateOnBlur={false}
                validateOnChange={false}>
                {({values, errors, handleSubmit, setFieldValue}) => (
                    <form onSubmit={handleSubmit} className="modal-body">
                        <Input
                            type="text"
                            value={values.name}
                            infoText={text.service_name_info}
                            placeholder={text.service_name}
                            name="name"
                            error={errors.name}
                            onChange={e => dispatch(setButtonIsDisabled(handleFormChanges(e, 'name', setFieldValue, initialFormValues)))}
                        />
                        <SimpleBlueButton
                            disabled={buttonIsDisabled}
                            type="submit">
                            {showLoader && <ButtonLoader/>}
                            <span>{text.submit}</span>
                        </SimpleBlueButton>
                    </form>
                )}
            </Formik>
        </div>
    )
}

export default EditPopup
